import { useState, type CSSProperties } from 'react';
import { Link } from 'react-router-dom';

const accordionSections = [
  {
    key: 'people',
    label: 'people',
    title: 'for our people',
    body: 'People have always been at the heart of the ZFAST story.',
    image: "/images/about/zfast-agritech-team.webp",
    position: 'center center',
    href: '/for-our-people'
  },
  {
    key: 'planet',
    label: 'planet',
    title: 'for our planet',
    body: 'Sustainability plays a key role in our purpose.',
    image: "/images/about/our-planet.webp",
    position: 'center center',
    href: '/for-our-planet'
  },
  {
    key: 'performance',
    label: 'performance',
    title: 'for our performance.',
    body: 'Financial performance without purpose is not meaningful, and purpose without performance is not sustainable.',
    image: "/images/about/our-performance.webp",
    position: 'center center',
    href: '/for-our-performance'
  }
];

export function PurposeAccordion() {
  const [activeAccordion, setActiveAccordion] = useState<string | null>(null);

  return (
    <section className="zfast-purpose-accordion " aria-label="ZFAST purpose pillars">
      <div
        className={["zfast-purpose-accordion", activeAccordion ? "is-active" : ""].join(' ')}
        onMouseLeave={() => setActiveAccordion(null)}
      >
        {accordionSections.map((section) => {
          const active = section.key === activeAccordion;
          return (
            <Link
              key={section.key}
              to={section.href}
              className={["zfast-purpose-card", active ? "is-active" : ""].join(' ')}
              style={{
                '--purpose-img': `url(${section.image})`,
                '--purpose-pos': section.position,
              } as CSSProperties}
              onMouseEnter={() => setActiveAccordion(section.key)}
              onFocus={() => setActiveAccordion(section.key)}
              onClick={(event) => {
                if (window.matchMedia('(max-width: 980px)').matches && !active) {
                  event.preventDefault();
                  setActiveAccordion(section.key);
                }
              }}
              aria-label={section.title}
            >
              <span className="zfast-purpose-content">
                <span className="zfast-purpose-kicker">for our</span>
                <span className="zfast-purpose-title">{section.label}{section.key === 'performance' ? '.' : ''}</span>
                <span className="zfast-purpose-copy">{section.body}</span>
                <span className="zfast-purpose-button">Read more</span>
              </span>
              <span className="zfast-purpose-corner" aria-hidden="true" />
            </Link>
          );
        })}
      </div>
    </section>
  );
}
